<div class="{{containerClass}}">
	<div class="row">
		<div class="col-md-12">
			<div id="wrapperResizeContent" class="inner-content">
				<div class="inner-content-box">{{{content}}}</div>
			</div>
		</div>
	</div>
</div>
